import { type ReactNode } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Button } from "@/components/ui/Button";
import { useBooleanState } from "@/hooks/use-boolean-state";
import { cn } from "@/libs/utils/tailwind/cn";
import ChevronDownIcon from "../../Header/assets/ChevronDownIcon";
import { SlotsToClasses } from "@nextui-org/react";

export default function CollapsibleNavSection({
  label,
  children,
  classNames,
}: CollapsibleNavSectionProps) {
  const [isOpen, setIsOpen] = useBooleanState(false);

  return (
    <div className={cn("flex flex-col gap-2", classNames?.wrapper)}>
      <Button
        variant="light"
        disableAnimation
        className={cn("h-auto w-full text-left font-normal text-xl text-primary data-[hover=true]:bg-transparent px-4 [&>span]:block [&>span]:w-full",
          classNames?.trigger,
        )}
        onPress={setIsOpen.toggle}
      >
        <span className="flex w-full items-center justify-between gap-2">
          <span>{label}</span>
          <ChevronDownIcon
            className={`size-5 shrink-0 text-primary transition-transform ${isOpen ? "rotate-180" : ""}`}
          />
        </span>
      </Button>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            className="overflow-hidden"
          >
            <div className={cn("flex flex-col gap-2 border-y-1 border-slate-100 bg-slate-50 py-1 pl-4",
              classNames?.content,
            )}>{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

interface CollapsibleNavSectionProps {
  label: string;
  children: ReactNode;
  classNames?: SlotsToClasses<"trigger" | "content" | "wrapper">;
}

